<div>
  <app-generic-form title="Login">

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" form-content>

      @if (infoMessage()) {
        <div class="alert alert-info" role="alert">
          <i class="bi bi-info-circle me-1" aria-hidden="true"></i>{{ infoMessage() }}
        </div>
      }

      <div class="mb-3">
        <label for="username" class="form-label">Username o Email</label>
        <input
          id="username"
          type="text"
          formControlName="userName"
          class="form-control"
          [class.is-invalid]="loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched"
          placeholder="Inserisci il tuo username">
        @if (loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched) {
          <div class="invalid-feedback">
            L'username è obbligatorio.
          </div>
        }
      </div>

      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          placeholder="Inserisci la tua password">
        @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
          <div class="invalid-feedback">
            La password è obbligatoria.
          </div>
        }
        <div class="text-end mt-1">
          <a routerLink="/forgot-password" class="text-decoration-none small text-muted">Password dimenticata?</a>
        </div>
      </div>

      <div class="mb-3 form-check">
        <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe">
        <label class="form-check-label" for="rememberMe">Ricordami</label>
      </div>

      <button
        type="submit"
        [disabled]="isLoading() || loginForm.invalid"
        class="btn btn-primary w-100 mt-4 d-inline-flex align-items-center justify-content-center"
        id="loginFormBtn">
        <i class="bi" [class.bi-hourglass-split]="isLoading()" [class.bi-box-arrow-in-right]="!isLoading()" aria-hidden="true"></i>
        <span class="ms-1">{{ isLoading() ? 'Accesso in corso...' : 'Login' }}</span>
      </button>

      <div class="my-3 text-center position-relative">
        <hr>
        <span class="position-absolute top-50 start-50 translate-middle px-2 bg-body text-muted small">oppure</span>
      </div>

      <div #googleBtn class="google-btn-container w-100 mb-2 d-flex justify-content-center"></div>

      <button class="btn btn-warning btn-sm w-100 mt-2 d-inline-flex align-items-center justify-content-center"
              type="button"
              id="signupFormBtn"
              routerLink="/signup">
        <i class="bi bi-person-plus me-1" aria-hidden="true"></i>Non hai un account?
      </button>

    </form>

  </app-generic-form>
</div>
